import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class LeerPesoDestare {
  static monitor () {
    const axios = getAxiosInstance()
    const promise = axios.get(`monitor_peso_destare`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static sinEquilibrio () {
    const axios = getAxiosInstance()
    const promise = axios.get(`leer_peso_destare`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static altaCpeEnDestare (cpe) {
    const axios = getAxiosInstance()
    const promise = axios.post(`consulta_cpe_en_destare`,
      `{"valores": { "numero": "${cpe.numero}", "peso_tara": "${cpe.pesoDestare}", 
        "chofer": "${cpe.chofer}", "error": "${cpe.error}", "error_descripcion":"${cpe.errorDescripcion}" }}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result.data[0])
  }

  static getCpePesadoDestare () {
    const axios = getAxiosInstance()
    const promise = axios.get(`cpe_en_destare`)
    return promise.then((result) => {
      const { data } = result
      if (data.estado === 'exito') {
        if (data.filas_procesadas > 0) {
          return data.filas[0]
        }
      }
    })
  }

  static deleteCpeEnDestare (numero) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`consulta_cpe_en_destare?r=` +
      `{"clave": {"numero": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data[0] })
  }
}

export default LeerPesoDestare
